export default __webpack_public_path__ + "static/media/marker.a4db6154.svg";